import React from 'react'
import { StyledInput } from './styled'
import { InputProps } from './types'

export const Input: React.FC<InputProps> = props => {
  return <StyledInput {...props} />
}
